(function () {
    const shareButtons = document.querySelectorAll("[data-share]");

    if (shareButtons.length) {
        shareButtons.forEach(button => {
            button.addEventListener("click", (e) => {
                e.preventDefault();

                const platform = button.getAttribute("data-share");
                const url = encodeURIComponent(window.location.href);
                const title = encodeURIComponent(document.title);
                let shareUrl = "";

                switch (platform) {
                    case "facebook":
                        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
                        break;
                    case "twitter": // Still using Twitter endpoint even though branded X
                        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
                        break;
                    case "linkedin":
                        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`;
                        break;
                    default:
                        return;
                }

                window.open(shareUrl, "_blank", "noopener,noreferrer,width=600,height=400");
            });
        });
    }

    // Media preview modal - unified function for images, videos, and Vimeo
    function openMediaPreviewModal({ type, mediaUrl, title, dimensions, formats, date, tags, downloadUrl, filename, category, vimeoId, vimeoUrl }) {
        // Build tags HTML
        const tagsHtml = tags.length > 0 
            ? tags.map(tag => `<span class="px-3 py-1.5 text-brand-secondary text-xs rounded" style="border: 1px solid #053739;">${tag.trim()}</span>`).join('')
            : '';
        
        // Build meta info
        const metaParts = [];
        if (dimensions && dimensions !== '0x0px') metaParts.push(dimensions);
        if (formats) metaParts.push(formats);
        if (date) metaParts.push(date);
        const metaHtml = metaParts.join('  |  ');
        
        // Media content (vimeo, video, or image)
        let mediaContent;
        if (type === 'vimeo') {
            mediaContent = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" 
                style="width: 80vw; max-width: 900px; height: 45vw; max-height: 506px;" 
                frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
        } else if (type === 'video') {
            mediaContent = `<video controls class="block" style="max-width: 80vw; max-height: 65vh; width: auto; height: auto;">
                   <source src="${mediaUrl}" type="video/mp4">
               </video>`;
        } else {
            mediaContent = `<img src="${mediaUrl}" alt="${title}" class="block" style="max-width: 80vw; max-height: 65vh; width: auto; height: auto;">`;
        }
        
        // Download button HTML
        let downloadBtnHtml = '';
        if (type === 'vimeo' && vimeoUrl) {
            downloadBtnHtml = `<a href="${vimeoUrl}" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-2 px-5 py-2.5 bg-brand-primary hover:bg-brand-primary/90 text-white text-sm font-semibold uppercase tracking-wide rounded no-underline transition-colors">
                    Download
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                        <path d="M12 16l-6-6h4V4h4v6h4l-6 6z"/>
                        <path d="M20 18H4v2h16v-2z"/>
                    </svg>
                </a>`;
        } else if (downloadUrl) {
            downloadBtnHtml = `<a href="${downloadUrl}" download="${filename}" class="inline-flex items-center gap-2 px-5 py-2.5 bg-brand-primary hover:bg-brand-primary/90 text-white text-sm font-semibold uppercase tracking-wide rounded no-underline transition-colors">
                    Download
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                        <path d="M12 16l-6-6h4V4h4v6h4l-6 6z"/>
                        <path d="M20 18H4v2h16v-2z"/>
                    </svg>
                </a>`;
        }
        
        const modal = document.createElement('div');
        modal.className = 'fixed inset-0 flex items-center justify-center p-4';
        modal.style.zIndex = '999999';
        modal.innerHTML = `
            <div class="absolute inset-0 bg-black/70 backdrop-blur-sm modal-backdrop"></div>
            <div class="relative bg-white overflow-hidden shadow-2xl" style="max-width: 95vw; max-height: 95vh;">
                <button class="modal-close-btn absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center bg-white/90 hover:bg-white text-gray-600 hover:text-gray-900 rounded-full text-xl leading-none shadow-md transition-colors">&times;</button>
                
                <div class="overflow-auto" style="max-height: calc(95vh - 2rem);">
                    <div class="bg-neutral-100 flex items-center justify-center p-4">
                        ${mediaContent}
                    </div>
                    
                    <div class="p-5">
                        <div class="flex flex-wrap items-end justify-between gap-4">
                            <div class="flex-1 min-w-0">
                                <h3 class="text-lg font-semibold text-brand-secondary m-0 mb-1">${title}</h3>
                                <p class="text-sm text-brand-secondary m-0">${metaHtml}</p>
                            </div>
                            
                            <div class="flex flex-col items-end gap-3">
                                <div class="flex flex-wrap justify-end gap-2">
                                    <span class="px-3 py-1.5 text-brand-secondary text-xs rounded" style="border: 1px solid #053739;">${category}</span>
                                    ${tagsHtml}
                                </div>
                                ${downloadBtnHtml}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        const closeModal = () => {
            const video = modal.querySelector('video');
            if (video) video.pause();
            modal.remove();
            document.removeEventListener('keydown', handleEsc);
        };
        
        const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
        };
        
        modal.addEventListener('click', (e) => {
            if (e.target.classList.contains('modal-backdrop') || e.target.closest('.modal-close-btn')) {
                closeModal();
            }
        });
        
        document.addEventListener('keydown', handleEsc);
        document.body.appendChild(modal);
    }

    // Video preview click handler
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.video-preview-btn');
        if (!btn) return;
        
        openMediaPreviewModal({
            type: 'video',
            mediaUrl: btn.dataset.videoUrl,
            title: btn.dataset.videoTitle || 'Video',
            formats: btn.dataset.videoFormats || '',
            date: btn.dataset.videoDate || '',
            tags: btn.dataset.videoTags ? btn.dataset.videoTags.split(',').filter(t => t.trim()) : [],
            downloadUrl: btn.dataset.downloadUrl || btn.dataset.videoUrl,
            filename: btn.dataset.filename || 'video.mp4',
            category: 'Video'
        });
    });

    // Vimeo preview click handler
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.vimeo-preview-btn');
        if (!btn) return;
        
        openMediaPreviewModal({
            type: 'vimeo',
            vimeoId: btn.dataset.vimeoId,
            vimeoUrl: btn.dataset.vimeoUrl,
            title: btn.dataset.vimeoTitle || 'Vimeo Video',
            date: btn.dataset.vimeoDate || '',
            tags: btn.dataset.vimeoTags ? btn.dataset.vimeoTags.split(',').filter(t => t.trim()) : [],
            category: 'Video'
        });
    });

    // Image preview click handler
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.image-preview-btn');
        if (!btn) return;
        
        const mediaCategory = btn.dataset.mediaCategory || 'image';
        
        openMediaPreviewModal({
            type: 'image',
            mediaUrl: btn.dataset.imageUrl,
            title: btn.dataset.imageTitle || 'File Name',
            dimensions: btn.dataset.imageDimensions || '',
            formats: btn.dataset.imageFormats || '',
            date: btn.dataset.imageDate || '',
            tags: btn.dataset.imageTags ? btn.dataset.imageTags.split(',').filter(t => t.trim()) : [],
            downloadUrl: btn.dataset.downloadUrl,
            filename: btn.dataset.filename,
            category: mediaCategory.charAt(0).toUpperCase() + mediaCategory.slice(1)
        });
    });

    // Multi-select dropdown functionality + async multimedia filtering
    const multiSelects = document.querySelectorAll('.multi-select');
    const selectedFilters = { mediaType: [], folder: [], tag: [] };
    const multiSelectRefs = {};

    const getSelectedFromOptions = (options) => Array.from(options).filter(o => o.checked);
    const applyMultiSelectLabel = (filterId) => {
        const ref = multiSelectRefs[filterId];
        if (!ref) return;
        const checked = getSelectedFromOptions(ref.options);
        selectedFilters[filterId] = checked.map(o => o.value);
        if (checked.length === 0) {
            ref.label.textContent = ref.defaultLabel;
        } else {
            ref.label.textContent = checked.length === 1
                ? checked[0].nextElementSibling.textContent
                : `${checked.length} selected`;
        }
    };

    multiSelects.forEach(ms => {
        const btn = ms.querySelector('.multi-select-btn');
        const dropdown = ms.querySelector('.multi-select-dropdown');
        const arrow = ms.querySelector('.multi-select-arrow');
        const label = ms.querySelector('.multi-select-label');
        const options = ms.querySelectorAll('.multi-select-option');
        const items = ms.querySelectorAll('.multi-select-item');
        const searchInput = ms.querySelector('.multi-select-search');
        const emptyState = ms.querySelector('.multi-select-empty');
        const filterId = ms.dataset.filterId;
        const defaultLabel = ms.dataset.defaultLabel;
        multiSelectRefs[filterId] = { options, label, defaultLabel };

        const resetSearch = () => {
            if (!searchInput) return;
            searchInput.value = '';
            items.forEach((item) => {
                item.style.display = '';
            });
            emptyState?.classList.add('hidden');
        };

        const filterOptions = () => {
            if (!searchInput) return;
            const term = searchInput.value.toLowerCase().trim();
            let visible = 0;
            items.forEach((item) => {
                const text = item.dataset.label || item.textContent.toLowerCase();
                const match = term === '' || text.includes(term);
                item.style.display = match ? '' : 'none';
                if (match) visible += 1;
            });
            emptyState?.classList.toggle('hidden', visible > 0);
        };

        btn.addEventListener('click', () => {
            const isOpen = !dropdown.classList.contains('hidden');
            document.querySelectorAll('.multi-select-dropdown').forEach(d => d.classList.add('hidden'));
            document.querySelectorAll('.multi-select-arrow').forEach(a => a.classList.remove('rotate-180'));
            document.querySelectorAll('.multi-select').forEach((other) => {
                if (other !== ms) {
                    const otherSearch = other.querySelector('.multi-select-search');
                    if (otherSearch) otherSearch.value = '';
                    other.querySelectorAll('.multi-select-item').forEach((item) => {
                        item.style.display = '';
                    });
                    other.querySelector('.multi-select-empty')?.classList.add('hidden');
                }
            });
            if (!isOpen) {
                dropdown.classList.remove('hidden');
                arrow.classList.add('rotate-180');
                if (searchInput) {
                    resetSearch();
                    requestAnimationFrame(() => searchInput.focus());
                }
            } else {
                resetSearch();
            }
        });

        searchInput?.addEventListener('input', filterOptions);
        searchInput?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') e.preventDefault();
            e.stopPropagation();
        });
        searchInput?.addEventListener('click', (e) => e.stopPropagation());

        options.forEach(opt => {
            opt.addEventListener('change', () => {
                applyMultiSelectLabel(filterId);
                if (typeof window.triggerFilter === 'function') {
                    window.triggerFilter();
                }
            });
        });

        applyMultiSelectLabel(filterId);
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.multi-select')) {
            document.querySelectorAll('.multi-select-dropdown').forEach(d => d.classList.add('hidden'));
            document.querySelectorAll('.multi-select-arrow').forEach(a => a.classList.remove('rotate-180'));
            document.querySelectorAll('.multi-select-search').forEach((input) => {
                input.value = '';
            });
            document.querySelectorAll('.multi-select-item').forEach((item) => {
                item.style.display = '';
            });
            document.querySelectorAll('.multi-select-empty').forEach((el) => {
                el.classList.add('hidden');
            });
        }
    });

    const root = document.getElementById('multimediaRoot');
    const grid = document.getElementById('multimediaGrid');

    if (root && grid) {
        const ajaxUrl = root.dataset.ajaxUrl;
        const ajaxNonce = root.dataset.ajaxNonce;
        const perPage = Number(root.dataset.perPage || 12);
        const categoryGrid = document.getElementById('multimediaCategoryGrid');
        const resultsSection = document.getElementById('multimediaResultsSection');
        const categoryCards = categoryGrid ? Array.from(categoryGrid.querySelectorAll('[data-category-card]')) : [];
        const search = document.getElementById('multimediaSearch');
        const sortSelect = document.getElementById('multimediaSort');
        const resultsCount = document.querySelector('[data-results-count]');
        const totalCount = document.querySelector('[data-total-count]');
        const resultsMeta = resultsCount ? resultsCount.closest('.mb-8') : null;
        const noResults = document.getElementById('noResults');
        const loadMoreBtn = document.getElementById('loadMoreBtn');
        const loadMoreContainer = document.getElementById('loadMoreContainer');
        const loadingBar = document.getElementById('multimediaLoading');
        const heroTitle = document.querySelector('[data-multimedia-hero-title]');
        const parentLink = document.querySelector('[data-multimedia-parent-link]');
        const defaultHeroTitle = heroTitle?.dataset.defaultTitle || heroTitle?.textContent.trim() || 'Media Library';

        let currentPage = 1;
        let hasMore = false;
        let isLoading = false;
        let prefetchedChunk = null;
        let prefetchPromise = null;

        const filtersActive = () => {
            const hasSearch = (search?.value || '').trim().length > 0;
            return hasSearch
                || selectedFilters.folder.length > 0
                || selectedFilters.mediaType.length > 0
                || selectedFilters.tag.length > 0;
        };

        const getFilterSignature = () => JSON.stringify({
            search: (search?.value || '').trim().toLowerCase(),
            sort: sortSelect?.value || 'name_asc',
            folder: [...selectedFilters.folder].sort(),
            mediaType: [...selectedFilters.mediaType].sort(),
            tag: [...selectedFilters.tag].sort(),
        });

        const clearPrefetch = () => {
            prefetchedChunk = null;
            prefetchPromise = null;
        };

        const setResultsMode = (enabled) => {
            if (categoryGrid) categoryGrid.classList.toggle('hidden', enabled);
            if (resultsSection) resultsSection.classList.toggle('hidden', !enabled);
            if (!enabled && noResults) noResults.classList.add('hidden');
            if (!enabled && loadingBar) loadingBar.classList.add('hidden');
        };

        const setHeroCategory = (categoryTitle = '') => {
            const hasCategory = categoryTitle.trim().length > 0;
            if (heroTitle) {
                heroTitle.textContent = hasCategory ? categoryTitle : defaultHeroTitle;
            }
            if (parentLink) {
                parentLink.classList.toggle('hidden', !hasCategory);
            }
        };

        const setFolderSelection = (categorySlug) => {
            const folderRef = multiSelectRefs.folder;
            if (!folderRef) {
                selectedFilters.folder = categorySlug ? [categorySlug] : [];
                return;
            }
            folderRef.options.forEach(opt => {
                opt.checked = opt.value === categorySlug;
            });
            applyMultiSelectLabel('folder');
        };

        const buildRequestParams = (page) => {
            const params = new URLSearchParams();
            params.append('action', 'brand_hub_filter_multimedia');
            params.append('nonce', ajaxNonce);
            params.append('search', (search?.value || '').trim());
            params.append('sort', sortSelect?.value || 'name_asc');
            params.append('page', String(page));
            params.append('per_page', String(perPage));

            selectedFilters.folder.forEach(value => params.append('categories[]', value));
            selectedFilters.mediaType.forEach(value => params.append('media_types[]', value));
            selectedFilters.tag.forEach(value => params.append('tags[]', value));

            return params;
        };

        const extractImageUrls = (html) => {
            const urls = new Set();
            const doc = new DOMParser().parseFromString(`<div>${html || ''}</div>`, 'text/html');
            doc.querySelectorAll('[style*="background-image"]').forEach((el) => {
                const style = el.getAttribute('style') || '';
                const match = style.match(/url\((['"]?)(.*?)\1\)/i);
                if (match?.[2]) {
                    urls.add(match[2]);
                }
            });
            doc.querySelectorAll('img').forEach((img) => {
                const src = img.getAttribute('src');
                if (src) urls.add(src);
            });
            return Array.from(urls);
        };

        const preloadChunkImages = (html) => {
            extractImageUrls(html).forEach((url) => {
                const img = new Image();
                img.src = url;
            });
        };

        const renderResponse = (data, append = false) => {
            if (!append) {
                grid.innerHTML = data.html || '';
            } else {
                grid.insertAdjacentHTML('beforeend', data.html || '');
            }

            const shown = grid.querySelectorAll('.card-item').length;
            if (resultsCount) resultsCount.textContent = shown;
            if (totalCount) totalCount.textContent = data.total_assets || 0;

            hasMore = !!data.has_more;
            if (loadMoreContainer) {
                loadMoreContainer.classList.toggle('hidden', !hasMore || (data.total_assets || 0) === 0);
            }

            if (noResults) {
                noResults.classList.toggle('hidden', (data.total_assets || 0) > 0);
            }

            const hasResults = (data.total_assets || 0) > 0;
            grid.classList.toggle('hidden', !hasResults);
        };

        const fetchResults = async ({ append = false } = {}) => {
            if (!ajaxUrl || !ajaxNonce || isLoading) return;
            isLoading = true;
            if (loadingBar) loadingBar.classList.remove('hidden');
            if (loadMoreBtn) loadMoreBtn.disabled = true;
            if (resultsMeta) resultsMeta.classList.add('hidden');
            if (!append) {
                grid.classList.add('hidden');
                if (noResults) noResults.classList.add('hidden');
            }

            const params = buildRequestParams(currentPage);

            try {
                const response = await fetch(ajaxUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                    body: params.toString(),
                });
                const payload = await response.json();
                if (!payload?.success) {
                    return;
                }
                renderResponse(payload.data, append);
                return payload.data;
            } catch (err) {
                console.warn('Failed to fetch multimedia assets', err);
            } finally {
                isLoading = false;
                if (loadingBar) loadingBar.classList.add('hidden');
                if (loadMoreBtn) loadMoreBtn.disabled = false;
                if (resultsMeta) resultsMeta.classList.remove('hidden');
            }
        };

        const prefetchNextPage = async () => {
            const signature = getFilterSignature();
            const nextPage = currentPage + 1;
            if (!hasMore) return;
            if (prefetchedChunk && prefetchedChunk.page === nextPage && prefetchedChunk.signature === signature) return;
            if (prefetchPromise) return;

            const params = buildRequestParams(nextPage);
            prefetchPromise = fetch(ajaxUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                body: params.toString(),
            })
                .then((response) => response.json())
                .then((payload) => {
                    if (!payload?.success || !payload?.data) return;
                    prefetchedChunk = {
                        page: nextPage,
                        signature,
                        data: payload.data,
                    };
                    preloadChunkImages(payload.data.html);
                })
                .catch(() => {})
                .finally(() => {
                    prefetchPromise = null;
                });
        };

        const runFilters = async ({ resetPage = true, force = false } = {}) => {
            if (!force && !filtersActive()) {
                grid.innerHTML = '';
                currentPage = 1;
                hasMore = false;
                clearPrefetch();
                setResultsMode(false);
                setHeroCategory();
                return;
            }

            setResultsMode(true);
            if (resetPage) {
                currentPage = 1;
                clearPrefetch();
            }
            const data = await fetchResults({ append: !resetPage });
            if (data) {
                prefetchNextPage();
            }
        };

        categoryCards.forEach(card => {
            card.addEventListener('click', (e) => {
                e.preventDefault();
                const categorySlug = card.dataset.category;
                const categoryTitle = card.dataset.categoryTitle || card.querySelector('h3')?.textContent.trim() || '';
                setFolderSelection(categorySlug);
                setHeroCategory(categoryTitle);
                runFilters({ resetPage: true, force: true });
            });
        });

        parentLink?.addEventListener('click', (e) => {
            e.preventDefault();
            if (search) search.value = '';
            selectedFilters.mediaType = [];
            selectedFilters.folder = [];
            selectedFilters.tag = [];
            Object.keys(multiSelectRefs).forEach((filterId) => {
                multiSelectRefs[filterId].options.forEach(opt => {
                    opt.checked = false;
                });
                applyMultiSelectLabel(filterId);
            });
            grid.innerHTML = '';
            currentPage = 1;
            hasMore = false;
            clearPrefetch();
            setResultsMode(false);
            setHeroCategory();
        });

        const searchBtn = search?.nextElementSibling;
        searchBtn?.addEventListener('click', () => runFilters({ resetPage: true }));
        search?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                runFilters({ resetPage: true });
            }
        });

        sortSelect?.addEventListener('change', () => {
            if (filtersActive()) {
                runFilters({ resetPage: true });
            }
        });

        loadMoreBtn?.addEventListener('click', async () => {
            if (!hasMore || isLoading) return;
            const expectedPage = currentPage + 1;
            const signature = getFilterSignature();

            if (prefetchedChunk && prefetchedChunk.page === expectedPage && prefetchedChunk.signature === signature) {
                currentPage = expectedPage;
                renderResponse(prefetchedChunk.data, true);
                clearPrefetch();
                prefetchNextPage();
                return;
            }

            currentPage = expectedPage;
            const data = await fetchResults({ append: true });
            if (data) {
                prefetchNextPage();
            }
        });

        window.triggerFilter = () => runFilters({ resetPage: true });
        setResultsMode(false);
    } else {
        window.triggerFilter = () => {};
    }
})();
